import * as React from 'react'

import { IconSearch } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CommandInputWrapperStyled } from '../../../../components/CommandInput'
import { GlobalSearchCombobox } from '../../../../components/GlobalSearchCombobox'

interface IGlobalSearchInputProps {
  listboxId: string
  query: string
  inputRef: React.RefObject<HTMLInputElement>
  activeDescendantId: string | undefined
  isExpanded: boolean
  onQueryChange: (value: string) => void
  onEnter: () => void
  onNavigateDown: () => void
  onNavigateUp: () => void
}

export const GlobalSearchInput = ({
  listboxId,
  query,
  inputRef,
  activeDescendantId,
  isExpanded,
  onQueryChange,
  onEnter,
  onNavigateDown,
  onNavigateUp,
}: IGlobalSearchInputProps) => {
  const intl = useProcurifyIntl()

  return (
    <CommandInputWrapperStyled>
      <IconSearch size={16} color='textSecondary' />
      <GlobalSearchCombobox
        ref={inputRef}
        listboxId={listboxId}
        query={query}
        activeDescendantId={activeDescendantId}
        isExpanded={isExpanded}
        placeholder={intl.formatMessage(messages.inputPlaceholder)}
        ariaLabel={intl.formatMessage(messages.inputAriaLabel)}
        onQueryChange={onQueryChange}
        onEnter={onEnter}
        onNavigateDown={onNavigateDown}
        onNavigateUp={onNavigateUp}
      />
    </CommandInputWrapperStyled>
  )
}
